export const FETCH_REDRAW_SAMPLES_REQUEST = "FETCH_REDRAW_SAMPLES_REQUEST";
export const FETCH_REDRAW_SAMPLES_SUCCESS = "FETCH_REDRAW_SAMPLES_SUCCESS";
export const FETCH_REDRAW_SAMPLES_FAILURE = "FETCH_REDRAW_SAMPLES_FAILURE";
